import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicInputPlaceholderDirective } from '@prlw/libs/dynamic-input-placeholder/dynamic-input-placeholder.directive';
import { DynamicInputPlaceholderComponent } from '@prlw/libs/dynamic-input-placeholder/dynamic-input-placeholder.component';

@NgModule({
  declarations: [
    DynamicInputPlaceholderDirective,
    DynamicInputPlaceholderComponent,
  ],
  imports: [CommonModule],
  exports: [DynamicInputPlaceholderDirective],
})
export class DynamicInputPlaceholderModule {}
